import(/* webpackMode: "eager" */ "/workspace/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Roboto\",\"arguments\":[{\"weight\":\"400\",\"subsets\":[\"latin\"]}],\"variableName\":\"roboto\"}");
;
import(/* webpackMode: "eager" */ "/workspace/src/app/globals.scss");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalStateProviderWrapper"] */ "/workspace/src/app/GlobalStateProviderWrapper.tsx");
